import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Box, Grid } from './grid';
import { keyframes } from '@emotion/react';
const on = 'rotateZ(00deg)';
const off = 'rotateZ(90deg)';
const prop = 'transform';
const b2 = keyframes({
  '0%': {
    [prop]: off
  },
  '33.3%': {
    [prop]: on
  },
  '66.3%': {
    [prop]: off
  },
  '100%': {
    [prop]: off
  }
});
const b3 = keyframes({
  '0%': {
    [prop]: off
  },
  '33.3%': {
    [prop]: off
  },
  '66.6%': {
    [prop]: on
  },
  '100%': {
    [prop]: off
  }
});
const sx = {
  borderRadius: 2,
  width: '100%',
  height: '100%'
};
const size = 50;
const Loader = t0 => {
  const $ = _c(12);
  const {
    isContained: t1
  } = t0;
  const isContained = t1 === undefined ? false : t1;
  const t2 = `loader-overlay${isContained ? " contained" : ""}`;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      zIndex: 5000
    };
    t4 = <Box position="absolute" backgroundColor="background" opacity="0.2" width="100%" height="100%" />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  const t5 = isContained ? "absolute" : "fixed";
  let t6;
  if ($[2] !== t5) {
    t6 = {
      position: t5,
      top: "50%",
      left: "50%",
      width: `${size}px`,
      height: `${size}px`,
      marginLeft: `-${size / 2}px`,
      marginTop: `-${size / 2}px`,
      transition: "transform 100ms"
    };
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Box sx={{
      ...sx,
      bg: "loaderColors.0",
      gridRow: "1/-1",
      transition: "ease 0.5s",
      transformOrigin: "bottom left"
    }} />;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box sx={{
      ...sx,
      bg: "loaderColors.1",
      animation: `${b2} 2s ease infinite`
    }} />;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Box sx={{
      ...sx,
      bg: "loaderColors.2",
      animation: `${b3} 2s ease infinite`
    }} />;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t6) {
    t10 = <Grid className="loader" gridTemplateColumns="1fr 1fr" gridTemplateRows="1fr 1fr" gridGap={`${size / 13}px`} sx={t6}>{t7}{t8}{t9}</Grid>;
    $[7] = t6;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== t10 || $[10] !== t2) {
    t11 = <Box className={t2} sx={t3}>{t4}{t10}</Box>;
    $[9] = t10;
    $[10] = t2;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};
export default Loader;